export const useDatabaseStore = defineStore('databaseStore', () => {
  const apps = ref([])
  const customers = ref([])
  const users = ref([])
  const eventCategories = ref([])
  const activities = ref([])
  const personasSetups = ref([])
  const personasGroups = ref([])
  const paymentSystems = ref([])
  const eventTaxes = ref([])
  const eventOptions = ref([])

  const isDatabaseRootStoreLoaded = ref(false)
  const isDatabaseStoreLoaded = ref(false)

  return {
    apps,
    customers,
    users,
    eventCategories,
    activities,
    personasSetups,
    personasGroups,
    paymentSystems,
    eventTaxes,
    eventOptions,

    isDatabaseRootStoreLoaded,
    isDatabaseStoreLoaded
  }
})
